import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { AddUserManagerReturnPos } from "../../../domain/useages/user-return-acknowledgement/add-user-manager-return-acknowledgement";
import { RemoteAddUserManagerReturnAcknowledgement } from "../../../data/usecases/user-return-acknowledgement/remote-add-user-manager-return-acknowledgement";

export interface AddUserManagerReturnPosInterface {
  AddUserManagerReturnPosState: FetchState;
  addUserManagerReturnPos: Function;
}

const initialStates = {
  AddUserManagerReturnPosState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useAddUserManagerReturnPosSlice: StateCreator<
  AddUserManagerReturnPosInterface
> = (set) => ({
  ...initialStates,
    addUserManagerReturnPos: async (payload: AddUserManagerReturnPos.Params) => {
  
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteAddUserManagerReturnAcknowledgement = new RemoteAddUserManagerReturnAcknowledgement(
      `${BASE_URL}${Endpoints.ADD_USER_MANAGER_RETURN_ACKNOWLEDGEMENT}`,

      axiosHttpClient
    );

    set(() => ({ AddUserManagerReturnPosState: FetchState.LOADING }));
    let result = await remoteAddUserManagerReturnAcknowledgement.add(payload);
    return result;
  },
});
